<template>
  <div>
    <wc-page-title title='Route Health Check'></wc-page-title>
    <v-container v-if='wos'>
      <v-data-table
        dense
        :items='sortedWOs'
        :headers='headers'
        :items-per-page='-1'
        hide-default-footer
      >
        <template v-slot:item.b='{ item }'>
          <span :class='getClassB(item)'>{{ item.b }} - {{ item.bid }}</span>
        </template>
        <template v-slot:item.a='{ item }'>
          <span :class='getClassA(item)'>{{ item.a }} - {{ item.aid }}</span>
        </template>
      </v-data-table>
      <v-row>
        <v-col>
          <v-select
            :items='wos'
            label='WO'
            item-value='id'
            item-text='project_name'
            v-model='wo'
            dense
            return-object
          ></v-select>
        </v-col>
        <v-col>
          <v-select
            label='Should come after...'
            v-model='comes_after'
            :items='wos'
            item-value='id'
            item-text='project_name'
            dense
          ></v-select>
        </v-col>
        <v-col>
          <v-btn depressed @click='fixWO' block color='info'>Fix</v-btn>
        </v-col>
      </v-row>
      <v-alert type='warning'>Do not edit anything here unless you know what you're doing!</v-alert>
      This area fixes out of order routes. Messing things up here can have some pretty awful consequences.
    </v-container>
  </div>
</template>

<script>
import scheduleAPI from '../api/schedule'
import miscServices from '@/services/misc'
import wosAPI from '@/modules/wos/api'
// import WOTile from './scheduleDetail/WOTile'
// import _ from 'lodash'

export default {
  namme: 'route-health-check',
  data: () => ({
    isLoading: false,
    wos: null,
    sortedWOs: [],
    scheduleSorted: [],
    wo: null,
    comes_after:null,
    headers: [
      { text: 'WO', value: 'b' },
      { text: 'Comes after', value: 'a' }
    ]
  }),
  mounted () {
    this.getData()
  },
  methods: {
    async getData () {
      this.wos = await scheduleAPI.getRouteWOs(this.$route.params.id)
      this.sortLikeSchedule()
      for (let i = 0; i < this.wos.length; i++) {
        let tmp = {}
        tmp.b = this.wos[i].project_name
        tmp.bid = this.wos[i].id
        let ca = this.wos.find(w => w.id === this.wos[i].comes_after)
        if (ca) {
          tmp.a = ca.project_name
          tmp.aid = ca.id
        } else {
          tmp.a = '1 - START'
          tmp.aid = null
        }
        this.sortedWOs.push(tmp)
      }
      for (let i = 0; i < this.sortedWOs.length; i++) {
        this.sortedWOs[i].is_duplicate = this.checkForDuplicate(this.sortedWOs[i])
        this.sortedWOs[i].is_missing = this.checkForMissing(this.sortedWOs[i])
      }
    },
    sortLikeSchedule () {
      this.scheduleSorted = miscServices.sortLineItems(this.wos)
    },
    checkForDuplicate (sortedWO) {
      let count = 0
      for (let i = 0; i < this.sortedWOs.length; i++) {
        if (this.sortedWOs[i].aid === sortedWO.aid) {
          count += 1
        }
      }
      return count > 1 ? true : false
    },
    checkForMissing (sortedWO) {
      let count = 0
      for (let i = 0; i < this.sortedWOs.length; i++) {
        if (this.sortedWOs[i].aid === sortedWO.bid) {
          count += 1
        }
      }
      return count === 0 ? true : false
    },
    getClassA (wo) {
      if (wo.is_duplicate) {
        return 'font-weight-bold error--text'
      }
      return ''
    },
    getClassB (wo) {
      if (wo.is_missing) {
        return 'font-weight-bold warning--text'
      }
      return ''
    },
    async fixWO () {
      if (this.wo && this.comes_after) {
        this.wo.comes_after = this.comes_after
        await wosAPI.updateWO(this.wo)
        this.wos = []
        this.scheduleSorted = []
        this.sortedWOs = []
        this.getData()
      }
    }
  // },
  // components: {
  //   'wo-tile': WOTile
  }
}
</script>
